// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const interestActions = require('../interest/actions')
// Sibling imports
const InterestProfileHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    interest: state.interest
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onFollowClick: dispatchAuthRequiredAction(
      interestActions.toggleFollowing,
      authModalActions.showSignup
    )
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    InterestProfileHeader
  )
)
